module.exports = __webpack_public_path__ + "static/media/thumbsUp.6730e726.svg";